import type { AdminOverview } from '@nestjs-boilerplate/types';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@/lib/api-client';

export type { AdminOverview };

export const adminQueryKeys = {
  all: ['admin'] as const,
  overview: () => [...adminQueryKeys.all, 'overview'] as const,
};

/**
 * Fetches the headline platform counts.
 *
 * Returns 403 for any caller without admin:users, which is the API-side gate
 * the client guard mirrors.
 */
export async function getAdminOverview(): Promise<AdminOverview> {
  return apiClient.fetch<AdminOverview>('/admin/overview');
}

/**
 * Query hook for the admin overview counts.
 */
export function useAdminOverview() {
  return useQuery({
    queryKey: adminQueryKeys.overview(),
    queryFn: getAdminOverview,
  });
}
